/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JourneyTypeResponse,
    JourneyTypeResponseFromJSON,
    JourneyTypeResponseFromJSONTyped,
    JourneyTypeResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface JourneyTypeResponseCriteriaResponse
 */
export interface JourneyTypeResponseCriteriaResponse {
    /**
     * 
     * @type {JourneyTypeResponse}
     * @memberof JourneyTypeResponseCriteriaResponse
     */
    value?: JourneyTypeResponse;
    /**
     * 
     * @type {boolean}
     * @memberof JourneyTypeResponseCriteriaResponse
     */
    exclude?: boolean;
}

export function JourneyTypeResponseCriteriaResponseFromJSON(json: any): JourneyTypeResponseCriteriaResponse {
    return JourneyTypeResponseCriteriaResponseFromJSONTyped(json, false);
}

export function JourneyTypeResponseCriteriaResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JourneyTypeResponseCriteriaResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : JourneyTypeResponseFromJSON(json['value']),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function JourneyTypeResponseCriteriaResponseToJSON(value?: JourneyTypeResponseCriteriaResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': JourneyTypeResponseToJSON(value.value),
        'exclude': value.exclude,
    };
}


